import { Injectable } from '@angular/core';
import { AntennaModel } from '../models/antennaModel';
import { HttpClient } from '@angular/common/http';
import { EndpointsService } from './endpoints.service';
import { firstValueFrom } from 'rxjs';
import { PointsService } from './points.service';
import { ModalControlService } from './modal-control.service';

@Injectable({
  providedIn: 'root'
})
export class SelectAntennaPatternService {

  antennaModels: AntennaModel[] = [];

  constructor(
    public http : HttpClient,
    public endpointService:EndpointsService,
    public pointsService: PointsService,
    private modalService : ModalControlService
  )
  { }


  async getAllAntennaModels(){
     this.antennaModels = await firstValueFrom(this.http.get<AntennaModel[]>(this.endpointService.antennaModelsAPI, this.endpointService.httpOptions));
     // return only for navaid antenna association modal
     return this.antennaModels;
  }

  downloadAntennaFile(modelName: string){
    this.http
      .get<Blob>(this.endpointService.downloadAntennaFile + `/${modelName}`, {
      headers : this.endpointService.httpOptions.headers,
      responseType: 'blob' as 'json'
      })
    .subscribe({
      next: data => {
        this.pointsService.downloadFile(data, modelName + ".csv");
        this.modalService.showMesssageModal(
          'Download successfull',
          'The Antenna Pattern File was downloaded successfully.'
        );
      },
      error: () => {
        this.modalService.showMesssageModal(
          'Error Downloading',
          'There was an error downloading the Antenna Pattern File.'
        );
      }
    })
  }

  async saveAntennaModel(antennaModel: FormData): Promise<AntennaModel>{
    return await firstValueFrom(this.http.post<AntennaModel>(this.endpointService.antennaModelsAPI, antennaModel, this.endpointService.httpOptions));
  }

  async updateAntennaModel(antennaModel: FormData): Promise<AntennaModel>{
    return await firstValueFrom(this.http.put<AntennaModel>(this.endpointService.antennaModelsAPI, antennaModel, this.endpointService.httpOptions));
  }

  async deleteAntennaModel(antennaModelId: number): Promise<boolean>{
    return await firstValueFrom(this.http.delete<boolean>(this.endpointService.antennaModelsAPI + `/${antennaModelId}`, this.endpointService.httpOptions));
  }




}
